import pdfMake from "pdfmake/build/pdfmake";
import { NumerosALetras } from 'numero-a-letras';
import { formatRemuneracion, cleanRemuneracion } from '../Validations/TrabajadoresValidation';
const vfsFonts = require("pdfmake/build/vfs_fonts");

pdfMake.vfs = vfsFonts;

const formatearFechaTexto = (fechaISO) => {
    if (!fechaISO) return "";
    const meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    const [year, month, day] = fechaISO.split("-").map(Number);
    if (!year || !month || !day) return "";
    const fecha = new Date(year, month - 1, day);
    return `${fecha.getDate()} DE ${meses[fecha.getMonth()]} DEL ${fecha.getFullYear()}`;
};

const toISOStored = (s) => (s ? s.split("-").reverse().join("-") : "");

/**
 * Genera el PDF del finiquito.
 *
 * @param {Object} params
 * @param {Object} params.datosTrabajador  Datos del trabajador y montos
 * @param {Object} params.datosEmpresa     Datos de la empresa empleadora
 * @param {string} params.logoBase64       Logo en base64 para marca de agua (opcional)
 * @param {boolean} params.openInNewTab    true = vista previa; false = descarga
 */
export const generarFiniquitoPDF = ({ datosTrabajador, datosEmpresa = {}, logoBase64 = null, openInNewTab = false }) => {
    const t = datosTrabajador || {};
    const e = datosEmpresa || {};

    const fechaFiniquitoTexto = formatearFechaTexto(t.FechaFiniquito);

    const total =
        Number((cleanRemuneracion(t.indemnizacion) || "0")) +
        Number((cleanRemuneracion(t.Vacaciones) || "0")) +
        Number((cleanRemuneracion(t.Faena) || "0")) +
        Number((cleanRemuneracion(t.MesAviso) || "0"));

    let liquidoEnLetras = NumerosALetras(total.toString().replace(".", ""));
    liquidoEnLetras = liquidoEnLetras.replace(/\s\d+\/\d+\sM\.N\.?$/, '');

    const nombreUpper = `${(t.Nombres || '').toUpperCase()} ${(t.Apellidos || '').toUpperCase()}`.trim();

    const empresaNombre = e.empresa || "";
    const empresaRut = e.rutEmpresa || "";
    const empresaDomicilio = e.domicilioEmpresa || "";
    const empresaComuna = e.comunaEmpresa || "";
    const empresaCiudad = e.ciudadEmpresa || "";
    const repLegal = e.representanteLegal || "";
    const repLegalRut = e.rutRepresentante || "";

    const docDefinition = {
        pageSize: 'LETTER',
        pageMargins: [40, 40, 40, 40],
        background: function (currentPage, pageSize) {
            if (!logoBase64) return null;
            return {
                image: logoBase64,
                width: 450,
                opacity: 0.06,
                absolutePosition: {
                    x: (pageSize.width - 450) / 2,
                    y: (pageSize.height - 159) / 2
                }
            };
        },
        content: [
            { text: "FINIQUITO DE CONTRATO DE TRABAJO", style: "header" },

            {
                text: [
                    { text: "En " },
                    { text: t.EnComuna || "", bold: true },
                    { text: ", a " },
                    { text: fechaFiniquitoTexto, bold: true },
                    { text: ", entre " },
                    { text: empresaNombre, bold: true },
                    { text: " R.U.T " },
                    { text: empresaRut, bold: true },
                    { text: " domiciliado en " },
                    { text: empresaDomicilio, bold: true },
                    { text: " comuna de " },
                    { text: empresaComuna, bold: true },
                    { text: " ciudad de " },
                    { text: empresaCiudad, bold: true },
                    { text: " representado por don (a) " },
                    { text: repLegal, bold: true },
                    { text: " C.I. " },
                    { text: repLegalRut, bold: true },
                    { text: ", por una parte; y la otra, don " },
                    { text: nombreUpper, bold: true },
                    { text: " cédula de identidad Nro. " },
                    { text: t.Rut || "", bold: true },
                    { text: ", de nacionalidad " },
                    { text: t.Nacionalidad || "", bold: true },
                    { text: " nacido el " },
                    { text: toISOStored(t.FechaNacimiento), bold: true },
                    { text: ", domiciliado en " },
                    { text: t.Domicilio || "", bold: true },
                    { text: " Comuna de " },
                    { text: t.Comuna || "", bold: true },
                    { text: ", Ciudad de " },
                    { text: empresaCiudad, bold: true },
                    { text: ", en adelante, también el trabajador, se deja testimonio y se ha acordado el finiquito que consta de las siguientes cláusulas:" },
                ],
                alignment: "justify",
                margin: [0, 5, 0, 15],
            },

            {
                text: [
                    { text: "PRIMERO: ", bold: true },
                    "El trabajador prestó servicios al empleador en el cargo de ",
                    { text: (t.Cargo || '').toUpperCase(), bold: true },
                    ", desde el ",
                    { text: toISOStored(t.Desde), bold: true },
                    " hasta el ",
                    { text: toISOStored(t.Hasta), bold: true },
                    ", fecha esta última en que su contrato de trabajo ha terminado de acuerdo con lo establecido en el ",
                    { text: (t.Articulo || '').toUpperCase(), bold: true }
                ],
                alignment: "justify",
                margin: [0, 0, 0, 15],
            },

            {
                text: [
                    { text: "SEGUNDO: ", bold: true },
                    { text: "don " },
                    { text: nombreUpper, bold: true },
                    ", declara recibir en este acto, a su entera satisfacción, de parte de ",
                    { text: empresaNombre, bold: true },
                    " la suma de:\n\n",
                    `•        Indemnización años de Servicio         $${t.indemnizacion || 0}.\n`,
                    `•        Vacaciones Proporcionales                 $${t.Vacaciones || 0}.\n`,
                    `•        Faena u Obras                                        $${t.Faena || 0}.\n`,
                    `•        Mes de Aviso                                          $${t.MesAviso || 0}.\n\n`,
                    `Son: $${formatRemuneracion(total)}.\n\n`,
                    `${liquidoEnLetras} pesos\n\n`,
                    "Don ",
                    { text: nombreUpper, bold: true },
                    ", declara haber analizado y estudiado detenidamente dicha liquidación, aceptándola en todas sus partes, sin tener observación alguna que formularle."
                ],
                alignment: "justify",
                margin: [0, 0, 0, 15],
            },

            {
                text: [
                    { text: "TERCERO: ", bold: true },
                    "En consecuencia, el empleador no adeuda a don ",
                    { text: nombreUpper, bold: true },
                    " ningún valor ni en especie ni en dinero, situación que el trabajador declara aceptar en este acto a su entera satisfacción."
                ],
                alignment: "justify",
                margin: [0, 0, 0, 15],
            },

            {
                text: [
                    { text: "CUARTO: ", bold: true },
                    "Don ",
                    { text: nombreUpper, bold: true },
                    ", deja constancia que durante el tiempo que prestó servicios a ",
                    { text: empresaNombre, bold: true },
                    ", recibió oportunamente el total de las remuneraciones, beneficios y demás prestaciones convenidas de acuerdo a su contrato de trabajo, clase de trabajo ejecutado y disposiciones legales pertinentes, y que en tal virtud el empleador nada le adeuda por tales conceptos, ni por horas extraordinarias, asignación familiar, feriado, indemnización por años de servicios, imposiciones previsionales, así como por ningún otro concepto, ya sea legal o contractual, derivado de la prestación de sus servicios, de su contrato de trabajo o de la terminación del mismo."
                ],
                alignment: "justify",
                margin: [0, 0, 0, 15],
            },

            {
                text: [
                    "En consecuencia, don ",
                    { text: nombreUpper, bold: true },
                    ", declara que no tiene reclamo alguno que formular en contra de ",
                    { text: empresaNombre, bold: true },
                    ", renunciando a todas las acciones que pudieran emanar del contrato que los vinculó."
                ],
                alignment: "justify",
                margin: [0, 0, 0, 15],
            },

            {
                text: [
                    { text: "QUINTO: ", bold: true },
                    "En virtud de lo anteriormente expuesto, don ",
                    { text: nombreUpper, bold: true },
                    ", manifiesta expresamente que ",
                    { text: empresaNombre, bold: true },
                    " nada le adeuda en relación con los servicios prestados, con el contrato de trabajo o con motivo de la terminación del mismo, por lo que libre y espontáneamente, y con el pleno y cabal conocimiento de sus derechos, otorga a su empleador, el más amplio, completo, total y definitivo finiquito por los servicios prestados o la terminación de ellos, ya diga relación con remuneraciones, cotizaciones previsionales, de seguridad social o de salud, subsidios, beneficios contractuales adicionales a las remuneraciones, indemnizaciones, compensaciones, o con cualquiera causa o concepto."
                ],
                alignment: "justify",
                margin: [0, 0, 0, 15],
            },

            {
                text: [
                    { text: "SEXTO: ", bold: true },
                    "Asimismo, declara el trabajador que, en todo caso, y a todo evento, renuncia expresamente a cualquier derecho, acción o reclamo que eventualmente tuviere o pudiere corresponderle en contra del empleador, en relación directa o indirecta con su contrato de trabajo, con los servicios prestados, con la terminación del referido contrato o dichos servicios, sea que esos derechos o acciones correspondan a remuneraciones, cotizaciones previsionales, de seguridad social o de salud, subsidios, beneficios contractuales adicionales a las remuneraciones, indemnizaciones compensaciones, vulneración de derechos y garantías laborales durante la relación laboral, o por causa o con ocasión del despido y/o con cualquier otra causa o concepto."
                ],
                alignment: "justify",
                margin: [0, 0, 0, 15],
            },

            {
                text: [
                    "Para constancia, las partes firman el presente finiquito en dos ejemplares, quedando uno en poder de cada una de ellas, y en cumplimiento de la legislación vigente, don ",
                    { text: nombreUpper, bold: true },
                    ", lo lee, firma y lo ratifica."
                ],
                alignment: "justify",
                margin: [0, 0, 0, 15],
            },

            {
                text: [
                    { text: "SEPTIMO: ", bold: true },
                    "De acuerdo con la ley 21.389, el empleador mediante declaración jurada, manifiesta que no ha recibido ninguna notificación judicial que implique retención alguna por concepto de pensión de alimentos, según se acredita con las últimas liquidaciones de sueldos pagadas que se presentan junto con el presente finiquito, liberando en este acto al ministro de fe autorizante de cualquier responsabilidad por el no pago de esta. Adicionalmente, cabe hacer presente que tampoco correspondería hacer retención alguna, por cuanto el presente finiquito no contempla el pago sustitutivo del aviso previo, ni la indemnización por años de servicio según lo estipula la ley 21.389."
                ],
                alignment: "justify",
                margin: [0, 0, 0, 25],
            },

            // Firmas
            {
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            { text: "____________________________________________", alignment: "center" },
                            { text: "____________________________________________", alignment: "center" }
                        ],
                        [
                            {
                                stack: [
                                    { text: nombreUpper, bold: true, alignment: "center" },
                                    { text: `TRABAJADOR`, alignment: "center", margin: [0, 5, 0, 0] },
                                    { text: `RUT Nro. ${t.Rut || ''}`, alignment: "center" }
                                ]
                            },
                            {
                                stack: [
                                    { text: empresaNombre, bold: true, alignment: "center" },
                                    { text: "EMPLEADOR", alignment: "center", margin: [0, 5, 0, 0] },
                                    { text: `RUT Nro. ${empresaRut}`, alignment: "center" }
                                ]
                            }
                        ]
                    ]
                },
                layout: 'noBorders',
                margin: [0, 20, 0, 0]
            }
        ],
        styles: {
            header: { fontSize: 14, bold: true, alignment: "center", margin: [0, 0, 0, 10] }
        },
        defaultStyle: { font: "Roboto", fontSize: 11 }
    };

    if (openInNewTab) {
        pdfMake.createPdf(docDefinition).open();
    } else {
        pdfMake.createPdf(docDefinition).download(`Finiquito ${nombreUpper}.pdf`);
    }
};
